import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import SettingCustomContext from '@/custom/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import CigarManage from './factoryCodeManage'

const FactoryCode = () => {
    const settingcontext = useContext(SettingContext)
    const settingCustomContext = useContext(SettingCustomContext)
    const usercommoncontext = useContext(UserCommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableFetch,
        // searchTableAction,
        search_fetch_data,
        // responseStatus: responseStatusSetting,
        // clearResponse: clearResponseCommuncation,
    } = settingcontext
    const {
        searchGroupTable,
        group_table_data,
        searchTableAction,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingCustomContext
    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext

    const [changeStatus, setChangeStatus] = useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        record: {},
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            status: 0,
            id: 0,
            table: 'factory_codes',
            where: 'factory_code',
        },
        onSubmit: (values) => {
            searchTableAction(values, false, 'factory_codes_delete')
        },
    })
    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'factory_codes_create' &&
                responseStatusSetting.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                searchTableFetch(formikView.values, 'factory_codes')
            } else if (
                responseStatusSetting.from === 'factory_codes_delete' &&
                responseStatusSetting.status === 'success'
            ) {
                searchTableFetch(formikView.values, 'factory_codes')
                setChangeStatus(false)
            }
            clearResponseCommuncation()
        }
    }, [responseStatusSetting])

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            primaryTable: 'factory_codes',
            orderby: 'fc.id,desc',
            filters: true,
            filters: {
                factory_name: {
                    value: '',
                    type: 'like',
                    field: 'fc.factory_name',
                },
                factory_code: {
                    value: '',
                    type: 'like',
                    field: 'fc.factory_code',
                },
                status: {
                    value: 1,
                    type: 'in',
                    field: 'fc.status',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'factory_codes')
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'factory_codes') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        searchTableFetch(formikView.values, 'factory_codes')
    }, [])

    const onClickEdit = (id, secondaryID, type) => {
        if (type == 'delete') {
            formikSelection.values.id = id
            setChangeStatus(!changeStatus)
        } else {
            toggleFullScreenPopup(true, type, id)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            buttonType: 'edit',
            clickType: 'edit',
            onclick: onClickEdit,
            tooltipTitle: 'Edit',
        })

        actionPush.push({
            buttonType: 'delete',
            clickType: 'delete',
            onclick: onClickEdit,
            tooltipTitle: 'Delete',
        })

        return actionPush
    }
    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'id',
        },
        {
            field: 'factory_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Factory Name',
            filterable: true,
            filterField: 'factory_name',
        },
        {
            field: 'factory_code',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Factory Code',
            filterable: true,
            filterField: 'factory_code',
        },
        {
            field: 'start_date',
            type: 'date',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Start Date',
            filterable: true,
            filterField: 'start_date',
        },
        {
            field: 'end_date',
            type: 'date',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'End Date',
            filterable: true,
            filterField: 'end_date',
        },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            if (action === 'delete') {
                getPreviousData({
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    primaryTable: 'projects',
                    customTable: 'custom_projects',
                    similars: {
                        category: {
                            value: formikSelection.values.id,
                            type: 'arrayin',
                            field: 'p.location_id',
                        },
                    },
                })
            } else if (action === 'deactive') {
                setChangeStatus(true)
            } else {
                setChangeStatus(true)
            }
        }
    }

    useEffect(() => {
        if (previous_data) {
            if (previous_data.records.length) {
                setAlert('Previous records exists!', 'error')
                formikSelection.values.action = ''
                formikSelection.values.id = 0
                clearPreviousData()
            } else if (formikSelection.values.action) {
                setChangeStatus(true)
            }
        }
    }, [previous_data])

    const tableActions = []
    // tableActions.push(
    //     {
    //         label: 'Move to Active',
    //         icon: <span className="material-icons">check_circle</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'active',
    //     },
    //     {
    //         label: 'Move to Deactive',
    //         icon: <span className="material-icons">block</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'deactive',
    //     },
    //     {
    //         label: 'Delete Permanently',
    //         icon: <span className="material-icons">cancel</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'delete',
    //     }
    // )

    const searchInfo = [
        {
            label: 'Enter Factory Code',
            placeholder: 'Enter Factory Code',
            class: 'col-md-4 col-sm-6 col-12',
            type: '',
            name: 'factory_code',

            filter: true,
            formik: formikView,
        },
        {
            label: 'Enter Factory Name',
            placeholder: 'Enter Factory Name',
            class: 'col-md-4 col-sm-6 col-12',
            type: '',
            name: 'factory_name',

            filter: true,
            formik: formikView,
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikView} />
                <div className="d-flex justify-content-between align-items-center mt-0 mb-4">
                    <Button
                        id="location_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Factory Code
                    </Button>
                </div>

                <CustomTable
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={search_fetch_data}
                    changeTableFunction={searchTableFetch}
                    fromVariable={'factory_codes'}
                />
            </div>
            <CigarManage
                record={search_fetch_data?.records}
                data={manage}
                function={toggleFullScreenPopup}
            />

            <CustomDialog
                title={'Confirm'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to delete this factory code ?</h5>
                <div className="actionWrapper">
                    <Button
                        id="location_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="location_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default FactoryCode
